import type { GroupKey } from "../hooks/useDue";
import type { DueTask } from "../types";
import { TaskRow } from "./TaskRow";

export interface TaskListProps {
  label: string;
  labelClass: "overdue" | "due" | "whenever" | "done";
  tasks: DueTask[];
  group: GroupKey;
  onToggle: (task: DueTask, group: GroupKey) => void;
  /** If set, the section still renders (with this copy) when `tasks` is
   * empty — matches the mock's "Done"/"Done today" sections. Sections
   * without an `emptyText` are omitted entirely when empty (matches the
   * mock's "Whenever you get a chance", which "renders only when the
   * person has at least one such task" — design-spec §2). */
  emptyText?: string;
}

export function TaskList({ label, labelClass, tasks, group, onToggle, emptyText }: TaskListProps) {
  if (tasks.length === 0 && emptyText === undefined) return null;

  return (
    <>
      <h2 class={`section-label ${labelClass}`}>{label}</h2>
      {tasks.length === 0 ? (
        <p class="empty-hint">{emptyText}</p>
      ) : (
        <ul class="task-list">
          {tasks.map((task) => (
            <TaskRow
              key={task.id}
              task={task}
              done={group === "done_today"}
              overdue={group === "overdue"}
              onToggle={(t) => onToggle(t, group)}
            />
          ))}
        </ul>
      )}
    </>
  );
}
